export class IndustryRequest {
  NAICS: number;
  SIC: string;
  ADD_SIC: string[] = [];
  IBIS: IBISIndustry;
  RPI: number;
  ROT: string;

  constructor(value: any = {}) {
    this.IBIS = new IBISIndustry();
    Object.assign(this, value);
  }
}

export class IBISIndustry{
  NAME: string;
  CODE: number;
  DATE: string;
  PRIOR: number;
  NEXT: number;

  constructor() {
    this.NAME = null;
    this.CODE = null;
    this.DATE = null;
    this.PRIOR = null;
    this.NEXT = null;
  }
}
